import graphql__4fc3b52119f34affb4da from "./__generated__/ApiKeyDeletionModalDeleteApiKeyMutation.graphql.ts";import { MessagePanel } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import ConfirmationModal from 'components/confirmation/ConfirmationModal'
import React, { useState } from 'react'
import { RRNLRequestError } from 'react-relay-network-modern'
import { usePortalMutation } from 'utils'

import { ApiKeyDeletionModalDeleteApiKeyMutation } from './__generated__/ApiKeyDeletionModalDeleteApiKeyMutation.graphql'
import { ApiKey } from './ApiKeyManager'
import { readableErrorMessage } from './utils'

type Props = {
  /** The API key to delete. Also used to
   * indicate whether the modal is open or closed. */
  apiKey: ApiKey | undefined
  /** Callback for closing the modal */
  onClose: () => void
  /** Callback for confirming the modal */
  onDeleted: () => void
}

const deleteApiKeyMutation = graphql__4fc3b52119f34affb4da

export default function ApiKeyDeletionModal({
  apiKey,
  onClose,
  onDeleted,
}: Props): React.ReactElement {
  const [deleteApiKey, isDeletingApiKey] =
    usePortalMutation<ApiKeyDeletionModalDeleteApiKeyMutation>(
      deleteApiKeyMutation,
      {
        mutationName: 'DeleteApiKey',
        sentryContext: { component: 'ApiKeyDeletionModal' },
      },
    )

  const [deletionError, setDeletionError] = useState<string>()

  const handleDeleteApiKey = () => {
    if (!!apiKey?.id) {
      setDeletionError(undefined)
      deleteApiKey({
        variables: { apiKeyId: apiKey.id },
        onCompleted: () => {
          onDeleted()
        },
        onError: (err) => {
          if (err instanceof RRNLRequestError) {
            setDeletionError(readableErrorMessage(err))
          } else {
            setDeletionError(err.message)
          }
        },
      })
    }
  }

  return (
    <ConfirmationModal
      open={!!apiKey && apiKey.viewerCanDelete}
      onCancel={onClose}
      onConfirm={handleDeleteApiKey}
      title="Delete API key?"
      confirmButtonText="Delete API key"
      cancelButtonDisabled={isDeletingApiKey}
      confirmButtonDisabled={isDeletingApiKey || !apiKey?.viewerCanDelete}
      variant="warning"
      description={
        <>
          Are you sure you want to delete this API key? You will need to{' '}
          <span className="font-medium text-foreground-normal">
            ensure all applications using this API key are updated
          </span>{' '}
          with a new API key. <br />
          <br />
          This action{' '}
          <span className="font-medium text-foreground-normal">
            cannot be undone
          </span>
          .
        </>
      }
    >
      {!!deletionError && (
        <MessagePanel
          message={deletionError}
          variant="danger"
          className="my-2"
        />
      )}
    </ConfirmationModal>
  )
}
